import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData, restAuthApi } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const accountAPI = createApi({
    reducerPath: 'accountAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        getCurrentUser: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.GET_CURRENT_USER,
                method: 'POST',
            }),
        }),
        updateAccountDetailsAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.UPDATE_ACCOUNT_DETAILS_ACTION,
                method: 'POST',
                data,
            }),
        }),
        changeMyPassword: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CHANGE_MY_PASSWORD,
                method: 'POST',
                data,
            }),
        }),
        resetPassword: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.RESET_PASSWORD,
                method: 'POST',
                data,
            }),
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.FORGOT_PASSWORD,
                method: 'POST',
                data,
            }),
        }),
        viewAccountDetails: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.VIEW_ACCOUNT_DETAILS,
                method: 'POST',
            }),
        }),
        updateAccountDetails: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.UPDATE_ACCOUNT_DETAILS,
                method: 'POST',
            }),
        }),
    }),
});

export const accountAuthAPI = createApi({
    reducerPath: 'accountAuthAPI',
    baseQuery: axiosBaseQuery(restAuthApi),
    endpoints: (builder) => ({
        resetPassword: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.RESET_PASSWORD,
                method: 'POST',
                data,
            }),
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.FORGOT_PASSWORD,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useGetCurrentUserMutation,
    useUpdateAccountDetailsActionMutation,
    useChangeMyPasswordMutation,
    useViewAccountDetailsMutation,
    useUpdateAccountDetailsMutation,
} = accountAPI;

export const { useResetPasswordMutation, useForgotPasswordMutation } = accountAuthAPI;
